export const startupAgreementPaymentOptions = [
  { text: 'Bank account', value: 'bankAccount' },
  { text: 'FNB eWallet', value: 'fnbEWallet' },
];
